import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Stack,
} from '@mui/material';
import { PictureAsPdf, Print } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export type ContractOutputAction = 'pdf' | 'print';

interface ContractOutputModalProps {
    open: boolean;
    onClose: () => void;
    onSelect: (action: ContractOutputAction) => void;
}

const ContractOutputModal = ({ open, onClose, onSelect }: ContractOutputModalProps) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            aria-labelledby="contract-output-dialog-title"
        >
            <DialogTitle id="contract-output-dialog-title">
                {t('contracts.outputModal.title')}
            </DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ mb: 2 }}>
                    {t('contracts.outputModal.description')}
                </DialogContentText>
                <Stack spacing={2}>
                    <Button
                        variant="outlined"
                        size="large"
                        startIcon={<PictureAsPdf />}
                        onClick={() => onSelect('pdf')}
                        sx={{ justifyContent: 'flex-start', textTransform: 'none', py: 1.5 }}
                    >
                        {t('contracts.outputModal.savePdf')}
                    </Button>
                    <Button
                        variant="outlined"
                        size="large"
                        startIcon={<Print />}
                        onClick={() => onSelect('print')}
                        sx={{ justifyContent: 'flex-start', textTransform: 'none', py: 1.5 }}
                    >
                        {t('contracts.outputModal.print')}
                    </Button>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} sx={{ textTransform: 'none' }}>
                    {t('contracts.outputModal.cancel')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ContractOutputModal;
